// limit in number of child messages fetched. Use this variable everywhere you query submessages or interact with the cache, or you may fail to read and write the right cache entry.
export const CHILD_LIMIT = 50;
export const UI_DEPTH = 1;
export const LIMIT = 20;
export const QUERY_PAGE_NAME = 'page';
